import React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import Button from '../../common/Button';

type AlertDialogProps = {
  title?: string;
  open: boolean;
  content: React.ReactNode;
  handleOnClose: () => void;
};

const AlertDialog = ({
  open,
  title = 'Alert',
  handleOnClose,
  content,
}: AlertDialogProps) => (
  <Dialog
    open={open}
    onClose={handleOnClose}
    aria-labelledby="alertTitle"
    aria-describedby="alertContent"
  >
    <DialogTitle id="alertTitle" style={{ cursor: 'move' }}>
      <h2 className="font-bold">{title}</h2>
    </DialogTitle>
    <DialogContent id="alertContent">
      <div className="min-w-[400px]">{content}</div>
    </DialogContent>
    <DialogActions>
      <Button
        autoFocus
        onClick={handleOnClose}
        tabIndex={3}
        variant="contained_blue"
      >
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);

export default AlertDialog;
